<template>
  <body>
    <div
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        text-align: center;
      "
    >
      <template>
        <div>
          <div>
            Teacher's ClassKey<br />
            <a @click.prevent="joinClass(teacherKey)">{{ teacherKey }}</a>
          </div>
          <div>
            Student's ClassKey1<br />
            <a @click="joinClass(studentKey)">{{ studentKey }}</a>
          </div>
          <div>
            Employee's ClassKey<br />
            <a @click="joinClass(employeeKey)">{{ employeeKey }}</a>
          </div>
          <div>
            Observation's ClassKey<br />
            <a @click="joinClass(observerKey)">{{ observerKey }}</a>
          </div>
        </div>
      </template>
    </div>
  </body>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  data() {
    return {
      teacherKey: "eyJDbGFzc3Jvb21JZCI6NDg5NjkyMywiVXNlcklkIjoyMjYzNjd9",
      studentKey: "eyJDbGFzc3Jvb21JZCI6NDg5NjkyMywiVXNlcklkIjoyMDM0NDh9",
      employeeKey: "eyJDbGFzc3Jvb21JZCI6NDg5NjkyMywiVXNlcklkIjoyMTcxMjR9",
      observerKey: "eyJDbGFzc3Jvb21JZCI6NDg5NjkyMywiVXNlcklkIjoyMzA4MDl9",
    };
  },
  methods: {
    joinClass(ClassKey) {
      if (ClassKey == "") {
        alert("Please fill the Class Key");
      } else {
        const baseUrl = window.location.origin;
        window.location.href = `${baseUrl}/#/?key=${ClassKey}`;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
a {
  cursor: pointer;
  color: blue;
  text-decoration: underline;
  display: block;
  margin-bottom: 10px;
  border: 1px solid black;
  border-radius: 10px;
}
</style>
